/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import PropTypes from 'prop-types';

const CommuityIcon = ({ width, height }) => {
  return (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 672.61 227.94"
      width="406"
      height="306"
      className="illustration"
      css={css`
        max-width: ${width || '100%'};
        max-height: ${height || '100%'};
        height: ${height || '100%'};
        width: ${width || '100%'};
        display: inline-block;
      `}
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="259.49"
          y1="336.73"
          x2="277.34"
          y2="336.73"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#e5c6d6"></stop>
          <stop offset="0.42" stopColor="#ead4d0"></stop>
          <stop offset="1" stopColor="#f0e9cb"></stop>
        </linearGradient>
        <linearGradient
          id="linear-gradient-2"
          x1="187.05"
          y1="338.23"
          x2="202.83"
          y2="338.23"
        ></linearGradient>
        <linearGradient
          id="linear-gradient-3"
          x1="235.69"
          y1="209.47"
          x2="233.26"
          y2="401.3"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#010101" stopOpacity="0"></stop>
          <stop offset="0.95" stopColor="#010101"></stop>
        </linearGradient>
        <linearGradient
          id="linear-gradient-4"
          x1="127.35"
          y1="218.24"
          x2="132.15"
          y2="288.57"
        ></linearGradient>
        <linearGradient
          id="linear-gradient-5"
          x1="129.66"
          y1="315.82"
          x2="136.97"
          y2="271.06"
        ></linearGradient>
        <linearGradient
          id="linear-gradient-6"
          x1="106.67"
          y1="277.63"
          x2="120.49"
          y2="269.98"
        ></linearGradient>
        <linearGradient
          id="linear-gradient-7"
          x1="149.47"
          y1="271.74"
          x2="163.93"
          y2="279.51"
        ></linearGradient>
        <linearGradient
          id="linear-gradient-8"
          x1="219.84"
          y1="291.67"
          x2="246.3"
          y2="291.67"
        ></linearGradient>
        <linearGradient
          id="linear-gradient-9"
          x1="233.23"
          y1="300.37"
          x2="247.16"
          y2="159.24"
        ></linearGradient>
        <linearGradient
          id="linear-gradient-10"
          x1="237.95"
          y1="206.01"
          x2="282.64"
          y2="206.01"
          gradientTransform="matrix(0.98, 0.19, -0.19, 0.98, 15.73, 9.91)"
        ></linearGradient>
        <linearGradient
          id="linear-gradient-11"
          x1="433.97"
          y1="367.44"
          x2="435.02"
          y2="211.39"
        ></linearGradient>
        <linearGradient
          id="linear-gradient-12"
          x1="411.64"
          y1="336.03"
          x2="529.02"
          y2="129.58"
        ></linearGradient>
        <linearGradient
          id="linear-gradient-13"
          x1="414.16"
          y1="285.87"
          x2="454.54"
          y2="285.87"
        ></linearGradient>
        <linearGradient
          id="linear-gradient-14"
          x1="434.78"
          y1="193.94"
          x2="458.65"
          y2="323.27"
        ></linearGradient>
        <linearGradient
          id="linear-gradient-15"
          x1="332.96"
          y1="292.57"
          x2="330.87"
          y2="344.84"
        ></linearGradient>
        <linearGradient
          id="linear-gradient-16"
          x1="330.44"
          y1="270.71"
          x2="347.12"
          y2="215.31"
        ></linearGradient>
        <linearGradient
          id="linear-gradient-17"
          x1="329.86"
          y1="306.92"
          x2="350.42"
          y2="246.61"
        ></linearGradient>
        <linearGradient
          id="linear-gradient-18"
          x1="312.48"
          y1="323.45"
          x2="324.1"
          y2="268.27"
        ></linearGradient>
        <linearGradient
          id="linear-gradient-19"
          x1="355.96"
          y1="321.43"
          x2="345.24"
          y2="260.37"
        ></linearGradient>
        <linearGradient
          id="linear-gradient-20"
          x1="530.72"
          y1="278.55"
          x2="541.51"
          y2="247.23"
        ></linearGradient>
        <linearGradient
          id="linear-gradient-21"
          x1="536.5"
          y1="200.97"
          x2="535.89"
          y2="242.42"
        ></linearGradient>
        <linearGradient
          id="linear-gradient-22"
          x1="511.87"
          y1="256.73"
          x2="560.2"
          y2="256.73"
        ></linearGradient>
      </defs>
      <title>Diversity 2</title>
      <path
        d="M670.65,284.22c-10.26,21.84-30.91,37.47-53.34,46.46a182.45,182.45,0,0,1-35.84,9.87c-11.5,2.06-23.23,3.42-34.89,4.57-18.65,1.87-37.39,3.42-56.08,4.69-2.59.2-5.13.4-7.72.56h0c-32.26,2.11-64.52,3.42-96.86,4.22h-.23c-2.11,0-4.26.12-6.37.16q-45.82,1-91.68.95-31.22,0-62.37-.2c-15.12-.08-30.24-.16-45.39-.59-31.15-.92-62.21-3.23-92.52-9.63-5.93-1.19-11.82-2.63-17.7-4.18-16.31-4.33-32.7-10.26-45.59-21.24S2.28,292,4.66,275.27C6.85,259.84,18,247,30.6,237.84s27-15.67,39.77-24.54c24.47-16.83,42.41-41.53,65.64-60,18.45-14.72,44.11-26.5,68.17-21.44,22.68,4.77,42.13,20.56,65,25.06,30,5.88,58.83-11.86,88-21.09a162.63,162.63,0,0,1,112.49,5.89c33.29,14.48,61.69,40.14,96.93,48.89,32.54,8.07,71.6,2.42,95.23,26.17C678.8,233.9,681,262.34,670.65,284.22Z"
        transform="translate(-4.27 -128.48)"
        fill="#95BD51"
        opacity="0.24"
        style={{ isolation: 'isolate' }}
      ></path>
      <path
        d="M277.34,355.45c-6.09.44-11.73.23-17.85.28.36-4.73,1.89-25.79,2.24-30.52.15-2,.41-4.24,1.95-5.54a6.82,6.82,0,0,1,3.2-1.27c2.35-.44,5.44-1,7.81-.46,2,.46,1.93,2.21,2,3.94C277,327.54,276.1,349.93,277.34,355.45Z"
        transform="translate(-4.27 -128.48)"
        fill="url(#linear-gradient)"
      ></path>
      <path
        d="M187.63,320.64,187.05,355l15.78.79s-.24-26.73-5.27-30.61A23.29,23.29,0,0,0,187.63,320.64Z"
        transform="translate(-4.27 -128.48)"
        fill="url(#linear-gradient-2)"
      ></path>
      <path
        d="M207,233.71c-2.19,6.34-2,13.21-1.9,19.91a294.78,294.78,0,0,1-.85,32.7c-.55,5.84-1.39,11.72-.68,17.53s3.22,11.72,8,15c3.42,2.34,7.64,3.18,11.76,3.62A117.89,117.89,0,0,0,236,323a51.71,51.71,0,0,0,13.5-1.3c4.38-1.18,8.59-3.54,11.19-7.25,2.4-3.43,3.25-7.69,3.9-11.83a190.83,190.83,0,0,0,.1-58.87,29,29,0,0,0-1.88-7.42c-1.46-3.3-4-6-6.49-8.61s-5.3-5.54-8.75-7a24.5,24.5,0,0,0-8.7-1.67C225.83,218.35,211.88,219.49,207,233.71Z"
        transform="translate(-4.27 -128.48)"
        fill="#ffe368"
      ></path>
      <path
        d="M258.78,280.16,257.44,283a24.91,24.91,0,0,1-.34-7.32l.48-9.05a48.4,48.4,0,0,0-.34-11.85c-.77-3.89-2.61-7.71-5.8-10.06-4.09-3-9.57-3.17-14.66-3.14-4.7,0-9.75.22-13.51,3a22.36,22.36,0,0,0-5,5.93,24.91,24.91,0,0,0-3.74,7.35,23.13,23.13,0,0,0-.55,5.58c-.15,9.58.34,19.34-2.27,28.57-.86,3-2,6-2.37,9.16a2.17,2.17,0,0,0,.28,1.57,2.21,2.21,0,0,0,1.21.6,96.77,96.77,0,0,0,11,1.84l19.75,2.54a21.59,21.59,0,0,0,6.61.18c1.51-.26,3-.85,4.47-1.12,5-.91,7.67-3.57,6.92-8.72A115.42,115.42,0,0,1,258.78,280.16Z"
        transform="translate(-4.27 -128.48)"
        fill="url(#linear-gradient-3)"
      ></path>
      <path
        d="M211.56,297.1a37,37,0,0,0-25,23c6.32,4,13.32,9.09,13.83,16.56.07.93.1,18.26.85,18.8a2.83,2.83,0,0,0,1.55.37q29.79,1.23,59.59-.09c.12-4,.23-24.31.34-28.34a3.64,3.64,0,0,1,.33-1.7,3.52,3.52,0,0,1,1.6-1.26A89.58,89.58,0,0,1,277.87,319a57.06,57.06,0,0,0-7.43-13.6c-2.86-3.88-17.92-12.23-42.81-11.93C222,293.53,217,295.66,211.56,297.1Z"
        transform="translate(-4.27 -128.48)"
        fill="#95BD51"
      ></path>
      <path
        d="M179.84,354.91c-31.15-.92-62.21-3.23-92.52-9.63.75-5,.91-10.06,1.67-15,1-6.44,3.42-13.08,8.63-17,5.69-4.22,13.09-4.34,19.53-6.76,6.76-2.51,15-.48,22.16,0,8.95.59,18.41,1.39,25.65,6.64,5,3.62,8.48,9.11,10.62,14.92s3,12,3.7,18.17C179.36,346.63,179.76,351.8,179.84,354.91Z"
        transform="translate(-4.27 -128.48)"
        fill="#95BD51"
      ></path>
      <path
        d="M120.41,299.67a28.28,28.28,0,0,1-16.56-4.14,18.43,18.43,0,0,1-3.49-2.71,28.32,28.32,0,0,1-3.23-4.23l-6-9a19.65,19.65,0,0,1-3.09-6,6.64,6.64,0,0,1,1.45-6.34c-1.56-5.92-2.34-13.29.62-18.65,1.86-3.38,5.22-5.66,7.69-8.63,2.92-3.53,4.78-8.2,8.81-10.38,4.41-2.38,9.79-.93,14.79-.6,8.9.57,17.94-2.65,26.64-.67a16.93,16.93,0,0,1,5.86,2.46c4.24,2.92,6.41,8,9.81,11.85s8.26,7,9.22,12c1,5.31-2.82,10.3-3.46,15.67-.37,3.05.32,6.16-.17,9.19-.87,5.36-5.44,9.64-10.63,11.2-3.28,1-7,1.16-9.51,3.51-2.08,2-3,5.32-5.72,6.29a8.36,8.36,0,0,1-3.31.23C133.9,300.32,126.66,299.27,120.41,299.67Z"
        transform="translate(-4.27 -128.48)"
        fill="#606161"
      ></path>
      <path
        d="M120.41,299.67a28.28,28.28,0,0,1-16.56-4.14,18.43,18.43,0,0,1-3.49-2.71,28.32,28.32,0,0,1-3.23-4.23l-6-9a19.65,19.65,0,0,1-3.09-6,6.64,6.64,0,0,1,1.45-6.34c-1.56-5.92-2.34-13.29.62-18.65,1.86-3.38,5.22-5.66,7.69-8.63,2.92-3.53,4.78-8.2,8.81-10.38,4.41-2.38,9.79-.93,14.79-.6,8.9.57,17.94-2.65,26.64-.67a16.93,16.93,0,0,1,5.86,2.46c4.24,2.92,6.41,8,9.81,11.85s8.26,7,9.22,12c1,5.31-2.82,10.3-3.46,15.67-.37,3.05.32,6.16-.17,9.19-.87,5.36-5.44,9.64-10.63,11.2-3.28,1-7,1.16-9.51,3.51-2.08,2-3,5.32-5.72,6.29a8.36,8.36,0,0,1-3.31.23C133.9,300.32,126.66,299.27,120.41,299.67Z"
        transform="translate(-4.27 -128.48)"
        fill="url(#linear-gradient-4)"
      ></path>
      <path
        d="M121.75,305.51a12.67,12.67,0,0,0-1.32,3.53,7.09,7.09,0,0,0,.92,4.33,11.19,11.19,0,0,0,9.05,5.56,14.17,14.17,0,0,0,10.13-3.71,6.83,6.83,0,0,0,2.4-3.72,10,10,0,0,0-.42-3.83,33.67,33.67,0,0,1-.84-7.88c0-2,.2-4.21-.82-6-1.15-2-3.49-2.86-5.71-3.3-3.11-.6-8.85-1.53-9.91,2.44C124.07,297.26,123.69,301.39,121.75,305.51Z"
        transform="translate(-4.27 -128.48)"
        fill="#775339"
      ></path>
      <path
        d="M122.27,305.42a2.77,2.77,0,0,0,.21.61,11.68,11.68,0,0,0,2.54,3.11,6.45,6.45,0,0,0,4.61,1.32,12,12,0,0,0,7.6-3.53c3.17-3.1,6.14-8.78,3.62-13.11-1.15-2-3.49-2.86-5.71-3.3-3.11-.6-8.85-1.53-9.91,2.44-.87,3.23-1.33,6.56-2.38,9.74C122.5,303.79,122.07,304.49,122.27,305.42Z"
        transform="translate(-4.27 -128.48)"
        fill="url(#linear-gradient-5)"
      ></path>
      <path
        d="M111,269.89c-1-.44-2.45-.52-3.09.41a2.76,2.76,0,0,0-.36,1.08c-.58,3.64,1.06,7.71,4.33,9.41a2,2,0,0,0,1.07.3c.88-.08,1.34-1.07,1.52-1.93C115.28,275.47,114.8,271.45,111,269.89Z"
        transform="translate(-4.27 -128.48)"
        fill="#775339"
      ></path>
      <path
        d="M150.61,271.69a5.06,5.06,0,0,1,1.32-1.44,1.77,1.77,0,0,1,1.86-.13,2.64,2.64,0,0,1,.9,1.81c.24,1.31.43,2.79-.33,3.9a4.17,4.17,0,0,1-1.57,1.28,2.52,2.52,0,0,1-1.92.37,2.38,2.38,0,0,1-1.25-1.32,2.87,2.87,0,0,1-.34-1.17A7.28,7.28,0,0,1,150.61,271.69Z"
        transform="translate(-4.27 -128.48)"
        fill="#775339"
      ></path>
      <path
        d="M115.33,284.47c2.82,5.84,7.25,11.5,13.53,13.1s13.43-1.59,17.57-6.77,5.79-12,6.07-18.6c.32-7.51-1.3-15.69-6.93-20.68A19.92,19.92,0,0,0,132,246.88,30.82,30.82,0,0,0,118,251C105.57,257.78,110.33,274.12,115.33,284.47Z"
        transform="translate(-4.27 -128.48)"
        fill="#775339"
      ></path>
      <path
        d="M111,269.89s-4.78-12.09,8.92-22.37,28.77,2.29,31.06,11.42S152.56,270,152.56,270s-4.63-15.53-17.07-15.76S116.4,259.48,111,269.89Z"
        transform="translate(-4.27 -128.48)"
        fill="#95BD51"
      ></path>
      <path
        d="M110.92,275.1c0-.49.1-1,0-1.47s-.38-1-.87-1.05a.94.94,0,0,0-.85.68,2,2,0,0,0,0,1.15,14.76,14.76,0,0,0,1,2.7c.19.41.41.88.85,1a.93.93,0,0,0,1.14-1.18C112,276.27,111,276.16,110.92,275.1Z"
        transform="translate(-4.27 -128.48)"
        fill="url(#linear-gradient-6)"
      ></path>
      <path
        d="M153.25,273a1.1,1.1,0,0,1,0-.87,1.19,1.19,0,0,1,.73-.47,1.71,1.71,0,0,1,.13.78c0,.6,0,1.19,0,1.79a2.38,2.38,0,0,1-.1.8,1.36,1.36,0,0,1-.75.81c-.29.13-.71.1-.84-.2-.23-.52.33-.93.65-1.21C153.54,274,153.45,273.61,153.25,273Z"
        transform="translate(-4.27 -128.48)"
        fill="url(#linear-gradient-7)"
      ></path>
      <path
        d="M223.13,289.78c-1.93,4.29-4.09,8.92-3,13.5,1.17,5,6.28,8.45,11.38,8.44s9.9-3.12,12.66-7.41a11.11,11.11,0,0,0,2-8.08c-.41-2-1.56-3.72-2-5.67-1-4.07,1-8.57-.55-12.46-1.25-3.17-4.55-5.06-7.84-6a11.05,11.05,0,0,0-6-.19c-3.65,1.11-4.22,3.75-4,7C225.94,282.77,224.68,286.32,223.13,289.78Z"
        transform="translate(-4.27 -128.48)"
        fill="url(#linear-gradient-8)"
      ></path>
      <path
        d="M227,289.45a10.59,10.59,0,0,0,6.13,4.25,7.14,7.14,0,0,0,7.23-1.73,12.11,12.11,0,0,0,4-9,5,5,0,0,0-1-3.25,5.07,5.07,0,0,0-2.18-1.31A15.45,15.45,0,0,0,227.93,280C224.48,282.15,224.89,286.28,227,289.45Z"
        transform="translate(-4.27 -128.48)"
        fill="url(#linear-gradient-9)"
      ></path>
      <path
        d="M217.08,276.18c2.84,5,7.08,9.41,12.47,11.08a17.1,17.1,0,0,0,17.5-5.06,29.61,29.61,0,0,0,4.43-7.3c2.62-5.67,4.62-11.76,4.72-18s-1.88-12.69-6.25-16.94a22.67,22.67,0,0,0-11.69-5.65c-5.68-1.06-11.79-.51-16.86,2.43a18.93,18.93,0,0,0-7.33,7.69c-1.65,3.23-1.35,5.78-1.46,9.19C212.34,261.69,213.05,269.06,217.08,276.18Z"
        transform="translate(-4.27 -128.48)"
        fill="url(#linear-gradient-10)"
      ></path>
      <path
        d="M209.85,254.25a1.74,1.74,0,0,0,.2,1,1.89,1.89,0,0,0,1.62.58,75.69,75.69,0,0,0,9.87-.48,28.11,28.11,0,0,0,.78-6.06,17.19,17.19,0,0,1,1.18,5.38,125.91,125.91,0,0,1,14.79-.42,11.27,11.27,0,0,1-.46-5.64,13.62,13.62,0,0,0,1.44,5.1,1.93,1.93,0,0,0,.66.85,2.31,2.31,0,0,0,1.92-.09,23.12,23.12,0,0,1,10.7-.92l.19-2.36a21.43,21.43,0,0,1,1.77,4.05,6.12,6.12,0,0,1,4.69-1.06l-1.37-8.2a12.57,12.57,0,0,0-5.88-10.1,39.57,39.57,0,0,0-6.84-4.81,23,23,0,0,0-13.7-2,32.76,32.76,0,0,0-13,5.17,13.32,13.32,0,0,0-3.79,3.38c-1,1.4-1,2.94-1.65,4.44C211.29,246.11,209.85,249.77,209.85,254.25Z"
        transform="translate(-4.27 -128.48)"
        fill="#ffe368"
      ></path>
      <path
        d="M482.78,350.37c-32.26,2.11-64.56,3.42-96.9,4.22a.67.67,0,0,1-.27-.28,2,2,0,0,1-.2-.88,93,93,0,0,1,1.11-15.91c.56-3.42,1.31-6.92,3.18-9.82s5.77-6.53,9.51-6.72c3.9-.16,8,.79,12,.75,4.78,0,9.55-.44,14.32-.91,9.39-.92,18.7-2.39,28.13-2.95,3.81-.2,7.71-.32,11.33-1.63,1.71-.63,3.54-1.55,5.29-.95a7,7,0,0,1,1.91,1.11c2.43,1.87,4.89,3.74,6.48,6.33,1.83,2.94,2.39,6.44,2.87,9.86C482.38,338.48,483.18,344.44,482.78,350.37Z"
        transform="translate(-4.27 -128.48)"
        fill="#95BD51"
      ></path>
      <path
        d="M482.74,350.37c-32.26,2.11-64.52,3.42-96.86,4.22h-.23s-.08,0-.12-.12a1.72,1.72,0,0,1-.16-.88,93,93,0,0,1,1.07-15.91c.56-3.46,1.31-6.92,3.22-9.86s5.73-6.53,9.47-6.69c3.9-.19,8,.76,12,.72,4.78,0,9.55-.4,14.32-.87,9.39-1,18.74-2.39,28.13-3,3.81-.24,7.75-.32,11.33-1.63,1.71-.64,3.58-1.55,5.29-1a7.15,7.15,0,0,1,1.91,1.15c2.43,1.83,4.89,3.74,6.49,6.32,1.82,2.91,2.38,6.41,2.9,9.83C482.3,338.56,483.1,344.48,482.74,350.37Z"
        transform="translate(-4.27 -128.48)"
        fill="url(#linear-gradient-11)"
      ></path>
      <path
        d="M415.42,249.77a52.09,52.09,0,0,0-9.83,47.77c1.1,3.64,2.63,7.43,1.73,11.13-1.07,4.41-5.23,7.27-7.91,10.94a2.55,2.55,0,0,0-.64,1.71c.09.8.86,1.33,1.58,1.69a16.1,16.1,0,0,0,6.18,1.69c1.93.13,3.92-.09,5.75.54a15.44,15.44,0,0,1,4.09,2.54c5.74,4.28,12.48,7,19.13,9.63,2.38.95,4.86,1.91,7.42,1.74a13.76,13.76,0,0,0,5.66-1.92,35.37,35.37,0,0,0,15.63-17.52,4.16,4.16,0,0,1,1.45-2.18c1.22-.72,2.85,0,4.15-.53,2.21-.95,1.44-4.42-.34-6s-4.29-2.65-5.16-4.88c-1.07-2.76.89-5.65,2.07-8.36,2.2-5.05,1.74-10.81,1.17-16.29-1.25-11.93-3.38-24.86-12.24-32.94-3.58-3.25-8-5.43-12.43-7.34-4.65-2-10.59-4-15.39-1.41A44.08,44.08,0,0,0,415.42,249.77Z"
        transform="translate(-4.27 -128.48)"
        fill="#95BD51"
      ></path>
      <path
        d="M412.2,291.84c-4-9.49-3-20.77,4.37-28-2.66,1.71-5.65,5.77-6.73,10.45-.79,3.38-.79,7.48-.87,10.95a32.36,32.36,0,0,0,7.67,21.5l1.4-2.33a104.63,104.63,0,0,0,15.09,16.66,5.53,5.53,0,0,1,1.56,1.85,6.91,6.91,0,0,1,.3,2.57,14.29,14.29,0,0,0,3.36,9,2.68,2.68,0,0,0,1.2.91,2.78,2.78,0,0,0,1.48-.12,27.89,27.89,0,0,0,14.55-10,29.07,29.07,0,0,1-12.82,4.57,5.08,5.08,0,0,1-2.9-.3A4.2,4.2,0,0,1,438,327a10.92,10.92,0,0,1,1-8.26,32.44,32.44,0,0,1,5.11-6.81l4.84-5.37a15.32,15.32,0,0,0,2.18-2.84,19.54,19.54,0,0,0,1.38-4c1-3.5,2.48-6.85,3.54-10.33s1.68-7.22.85-10.77-3.37-6.85-6.88-7.81a15.89,15.89,0,0,0-4.52-.35l-14.53.22a16.92,16.92,0,0,0-6.14.85c-3.35,1.37-7.21,5.45-9.42,8.27a9.25,9.25,0,0,0-1.68,4.36C413.35,285.67,411.6,290.42,412.2,291.84Z"
        transform="translate(-4.27 -128.48)"
        fill="url(#linear-gradient-12)"
      ></path>
      <path
        d="M433.64,261.78a4.56,4.56,0,0,1,2.34-.6,5.39,5.39,0,0,1,2.41,1.18c5.11,3.51,11.92,5.38,14.75,10.91,1.64,3.22,1.52,7,1.21,10.63-.5,5.7-1.44,11.48-4.15,16.51s-7.46,9.25-13.12,10c-7.42,1-14.63-4.1-18.25-10.67C415.72,294.13,412,283,415.74,277,419.81,270.55,426.81,265,433.64,261.78Z"
        transform="translate(-4.27 -128.48)"
        fill="url(#linear-gradient-13)"
      ></path>
      <path
        d="M448.2,266.2c1.24.94,7.15,7.31,8.57,8s2.43-24.21-16-32.26c-1.26-.55-2.88-1.2-3.79-.16-.69.78-.44,2-.21,3a42,42,0,0,1,.95,8.29c.06,2.06-.62,5.18.39,7C439.9,263.26,445.35,264.06,448.2,266.2Z"
        transform="translate(-4.27 -128.48)"
        fill="url(#linear-gradient-14)"
      ></path>
      <path
        d="M379.28,354.75q-45.82,1-91.68.95c.19-6.84.55-15.71,1.67-24.46a27.71,27.71,0,0,1,13.12-20c.64-.36,1.32-.8,1.47-1.51a3.22,3.22,0,0,0-.31-1.47c-1-3.3,2.06-7.2,5.57-6.92.19-3.23,3.26-5.69,6.44-6.21,6.48-1,12.33,3.9,19,3.54,3.74-.16,7.44-.91,11.18-.72a44.05,44.05,0,0,1,9.51,1.79,9.6,9.6,0,0,1,3.34,1.44c2.58,1.95,2.58,5.8,2.34,9,6.73,1.51,11.86,7.12,14.64,13.4s3.54,13.21,4.26,20C379.84,344,379.56,349.77,379.28,354.75Z"
        transform="translate(-4.27 -128.48)"
        fill="#95BD51"
      ></path>
      <path
        d="M316.23,303c-.88-1.31-1.65-3.16-.6-4.34.79-.88,2.14-.84,3.31-.73l28.73,2.66a3.14,3.14,0,0,1,1.95.65,2.28,2.28,0,0,1-.19,3,16.42,16.42,0,0,1-2.58,2c-1.76,1.4-2.86,3.6-4.88,4.59a10,10,0,0,1-4.35.67l-10.31,0c-2.33,0-4.45-.24-6-2.09C319.62,307.33,317.75,305.22,316.23,303Z"
        transform="translate(-4.27 -128.48)"
        fill="url(#linear-gradient-15)"
      ></path>
      <path
        d="M308.63,252a35.85,35.85,0,0,0,1.28-3.74c.75-3.2.08-6.55.15-9.84s1.19-7,4.17-8.38c2.65-1.25,5.75-.26,8.67-.11,5.57.27,11-2.64,16.52-2.21a14.17,14.17,0,0,1,10.51,6.12c1.8,2.68,2.72,6.05,5.24,8.07.77.62,1.66,1.08,2.46,1.66a13,13,0,0,1,4.64,7.78,39,39,0,0,1,.53,9.22c-.09,3.89-.29,8.1-2.75,11.11s-6.7,4.09-10.62,4.72a114.42,114.42,0,0,1-31.58.66c-5.23-.62-9.53-2-10.59-7.54A33.47,33.47,0,0,1,308.63,252Z"
        transform="translate(-4.27 -128.48)"
        fill="#606161"
      ></path>
      <path
        d="M308.63,252a35.85,35.85,0,0,0,1.28-3.74c.75-3.2.08-6.55.15-9.84s1.19-7,4.17-8.38c2.65-1.25,5.75-.26,8.67-.11,5.57.27,11-2.64,16.52-2.21a14.17,14.17,0,0,1,10.51,6.12c1.8,2.68,2.72,6.05,5.24,8.07.77.62,1.66,1.08,2.46,1.66a13,13,0,0,1,4.64,7.78,39,39,0,0,1,.53,9.22c-.09,3.89-.29,8.1-2.75,11.11s-6.7,4.09-10.62,4.72a114.42,114.42,0,0,1-31.58.66c-5.23-.62-9.53-2-10.59-7.54A33.47,33.47,0,0,1,308.63,252Z"
        transform="translate(-4.27 -128.48)"
        fill="url(#linear-gradient-16)"
      ></path>
      <path
        d="M322.05,306.89a3.27,3.27,0,0,0-.51,2.34,3,3,0,0,0,.89,1.16c2.67,2.47,5.55,5,9.08,5.87a12,12,0,0,0,13.57-6.6,4.08,4.08,0,0,0,.37-1.31,6.63,6.63,0,0,0-1-2.83c-.89-2.08-.75-4.43-.81-6.7s-.45-4.71-2.07-6.28a8.1,8.1,0,0,0-5.48-1.87c-2.71-.09-10.58.4-11.8,3.27-.71,1.69-.19,4.72-.47,6.6A22.3,22.3,0,0,1,322.05,306.89Z"
        transform="translate(-4.27 -128.48)"
        fill="#f1b475"
      ></path>
      <path
        d="M323.94,295.92a41.46,41.46,0,0,0,1.82,5.59,7.06,7.06,0,0,0,4.14,3.95c1.91.55,3.94-.09,5.78-.84a19.58,19.58,0,0,0,3.57-1.8,20.26,20.26,0,0,0,3.27-2.87,13.39,13.39,0,0,0,2.45-3.22A4.86,4.86,0,0,0,343.1,290a13,13,0,0,0-3.48-1.38,26.07,26.07,0,0,0-8.13-1c-2.12.11-5.54.53-7.11,2.15S323.36,294.07,323.94,295.92Z"
        transform="translate(-4.27 -128.48)"
        fill="url(#linear-gradient-17)"
      ></path>
      <path
        d="M307.25,270a6.9,6.9,0,0,0,4.22,10.95,2.72,2.72,0,0,0,2.72-.7,2.55,2.55,0,0,0,.42-1.08,13.64,13.64,0,0,0-1.69-7.77C311.88,269.62,308.7,268.05,307.25,270Z"
        transform="translate(-4.27 -128.48)"
        fill="#f1b475"
      ></path>
      <path
        d="M361.81,267c1.23.19,1.93,1.53,2.15,2.75a7.6,7.6,0,0,1-2.68,7.15,3.63,3.63,0,0,1-1.61.79,2,2,0,0,1-1.69-.45,2.93,2.93,0,0,1-.66-1.92c-.13-1.74-.26-4.06.71-5.61C358.75,268.56,360.32,266.78,361.81,267Z"
        transform="translate(-4.27 -128.48)"
        fill="#f1b475"
      ></path>
      <path
        d="M311.33,267.87c-.05,7.09,1.18,14.34,4.82,20.42s10,10.81,17,11.34a33.88,33.88,0,0,0,9.28-1,21.83,21.83,0,0,0,4.7-1.36c4.13-1.87,6.8-6,8.63-10.1a47.51,47.51,0,0,0,1.68-33.55c-.62-1.92-1.67-4.06-3.65-4.46a4.84,4.84,0,0,0-2.38.24c-3,.94-5.58,3.06-8.57,4.13-3.77,1.35-8,.92-11.85,0s-7.69-2.33-11.66-2.9a7.69,7.69,0,0,0-3.54.12C310.26,252.66,311.36,263.4,311.33,267.87Z"
        transform="translate(-4.27 -128.48)"
        fill="#f1b475"
      ></path>
      <path
        d="M330.35,322.27a98.26,98.26,0,0,1-14-1.42,38.8,38.8,0,0,0-6.78-.85,16.37,16.37,0,0,0-13.78,8c-1.53-2.22-1.16-5.34.2-7.67s3.54-4.06,5.66-5.73a7.79,7.79,0,0,1,2.57-1.54c3.66-1.05,8.39,3.57,11.53,5A51.28,51.28,0,0,0,330.35,322.27Z"
        transform="translate(-4.27 -128.48)"
        fill="url(#linear-gradient-18)"
      ></path>
      <path
        d="M340.61,322.77c8.44-1.21,17.19-2.41,25.37,0a4.93,4.93,0,0,0,3.39.23,3,3,0,0,0,1.33-1.35,5.28,5.28,0,0,0-.36-4.93,12,12,0,0,0-3.61-3.61c-1.74-1.23-5-3.24-7.26-2.24-1.71.76-3.22,3.57-4.69,4.86A30.91,30.91,0,0,1,340.61,322.77Z"
        transform="translate(-4.27 -128.48)"
        fill="url(#linear-gradient-19)"
      ></path>
      <path
        d="M581.47,340.55c-11.5,2.06-23.23,3.42-34.89,4.57-18.65,1.87-37.39,3.42-56.08,4.69-.84-12.69-1.51-38.62.08-44a31.24,31.24,0,0,1,11.14-16.71c1,0,3.85-2.34,4.89-2.86a48,48,0,0,1,5.65-2.11,93.3,93.3,0,0,1,10.46-2.7c7.87-1.63,17.18.12,25.22.47,4.93.2,10,.44,14.44,2.63a26.28,26.28,0,0,1,9.5,8.83C576.46,299.89,580.16,324.32,581.47,340.55Z"
        transform="translate(-4.27 -128.48)"
        fill="#95BD51"
      ></path>
      <path
        d="M523.4,280c-.7,1.7-1.59,3.41-1.55,5.25a7.86,7.86,0,0,0,2.36,5.06A13.06,13.06,0,0,0,535,294.5a11.2,11.2,0,0,0,9.11-6.88,5.63,5.63,0,0,0,.43-2.06,9.29,9.29,0,0,0-.6-2.63,32.47,32.47,0,0,1-1.53-11.7c.13-2.47.35-5.41-1.61-6.92a5.7,5.7,0,0,0-2-.9,19.27,19.27,0,0,0-10.57,0c-3.92,1.11-2.82,3.2-2.84,6.51A27.21,27.21,0,0,1,523.4,280Z"
        transform="translate(-4.27 -128.48)"
        fill="#775339"
      ></path>
      <path
        d="M531.93,277.51c2.51,1.05,5.68.95,7.67-.9s2.29-4.63,2.56-7.23l.37-3.59a1,1,0,0,0-1.17-1.28,54.73,54.73,0,0,0-9.32-.23c-2.07.12-5,0-6.1,2.17C524,270.51,528.44,276.05,531.93,277.51Z"
        transform="translate(-4.27 -128.48)"
        fill="url(#linear-gradient-20)"
      ></path>
      <path
        d="M513.65,256.19a30.59,30.59,0,0,0,5.08,8.38c5.25,5.75,14,7.68,21.49,5.53s13.63-8,17.06-15,4.32-15.06,3.5-22.81c-.45-4.28-1.48-8.66-4.13-12a18.94,18.94,0,0,0-8.24-5.78,26.68,26.68,0,0,0-32.15,10.65C510,235.07,508.92,245.5,513.65,256.19Z"
        transform="translate(-4.27 -128.48)"
        fill="#775339"
      ></path>
      <path
        d="M506.56,243.7a4.43,4.43,0,0,0-.63,3.75,9.33,9.33,0,0,0,1.86,3.43,3.28,3.28,0,0,0,2.21,1.48,2.7,2.7,0,0,0,2.16-1.27C514.92,247.32,510.08,239.11,506.56,243.7Z"
        transform="translate(-4.27 -128.48)"
        fill="#775339"
      ></path>
      <path
        d="M562,241.07a3.48,3.48,0,0,1,3.2,1.82,5,5,0,0,1,.35,3.77,9.25,9.25,0,0,1-1.87,3.37,6.47,6.47,0,0,1-2.84,2.22,2.92,2.92,0,0,1-3.29-.9A4.06,4.06,0,0,1,557,250C556.27,247,558.29,241.41,562,241.07Z"
        transform="translate(-4.27 -128.48)"
        fill="#775339"
      ></path>
      <path
        d="M512.37,245.1c1-.26,1.11-1.63,1-2.66a28.78,28.78,0,0,1,3.29-15.09c1.78,1.63,4.58.7,6.87-.08,9.76-3.35,20.41-2.27,30.7-1.37a2.11,2.11,0,0,1,1.19.36,1.88,1.88,0,0,1,.47.7,39,39,0,0,1,3.85,16,12.47,12.47,0,0,1,3.38-2c.54-2.69-.18-5.45-.91-8.1-1.5-5.5-3.12-11.23-6.93-15.48-5.2-5.8-13.59-7.73-21.37-7.36-8.51.41-17.51,3.73-22,11-2.49,4.07-3.25,8.87-3.33,13.57,0,1.92-.39,4.89.33,6.71C509.29,242.15,511.71,245.26,512.37,245.1Z"
        transform="translate(-4.27 -128.48)"
        fill="#606161"
      ></path>
      <path
        d="M512.37,245.31c1-.25,1.11-1.62,1-2.65a28.76,28.76,0,0,1,3.29-15.09c1.78,1.62,4.58.7,6.87-.09,9.76-3.34,20.41-2.27,30.7-1.36a2.11,2.11,0,0,1,1.19.36,1.93,1.93,0,0,1,.47.69,39.1,39.1,0,0,1,3.85,16,12.7,12.7,0,0,1,3.38-2c.54-2.69-.18-5.46-.91-8.1-1.5-5.51-3.12-11.23-6.93-15.48-5.2-5.8-13.59-7.74-21.37-7.36-8.51.41-17.51,3.73-22,11-2.49,4.07-3.25,8.88-3.33,13.58,0,1.92-.39,4.89.33,6.71C509.29,242.37,511.71,245.48,512.37,245.31Z"
        transform="translate(-4.27 -128.48)"
        fill="url(#linear-gradient-21)"
      ></path>
      <path
        d="M515.06,260.69a17.88,17.88,0,0,0,2,4.39,17.14,17.14,0,0,0,6.85,5.41,22.49,22.49,0,0,0,4.39,1.69,26.45,26.45,0,0,0,6.53.54c4.67,0,9.33-.31,14-.61a6.13,6.13,0,0,0,2.94-.7,5.73,5.73,0,0,0,1.8-2.26,37.33,37.33,0,0,0,4.79-14.85,53.13,53.13,0,0,1,.41-5.5c.49-2.7,1.78-5.34,1.41-8.06-1.16.31-1.8,1.53-2.28,2.64-1,2.24-1.89,4.51-3,6.69a14.6,14.6,0,0,1-2.46,3.74c-2.46,2.55-6.21,3.37-9.75,3.66-2.7.21-5.41.18-8.12.13-4.27-.08-8.82-.3-12.31-2.75-4.26-3-5.74-8.91-10.18-11.57-.49.82.25,2.22.32,3.13.11,1.66.26,3.31.5,5A55.37,55.37,0,0,0,515.06,260.69Z"
        transform="translate(-4.27 -128.48)"
        fill="#606161"
      ></path>
      <path
        d="M515.06,260.69a17.88,17.88,0,0,0,2,4.39,17.14,17.14,0,0,0,6.85,5.41,22.49,22.49,0,0,0,4.39,1.69,26.45,26.45,0,0,0,6.53.54c4.67,0,9.33-.31,14-.61a6.13,6.13,0,0,0,2.94-.7,5.73,5.73,0,0,0,1.8-2.26,37.33,37.33,0,0,0,4.79-14.85,53.13,53.13,0,0,1,.41-5.5c.49-2.7,1.78-5.34,1.41-8.06-1.16.31-1.8,1.53-2.28,2.64-1,2.24-1.89,4.51-3,6.69a14.6,14.6,0,0,1-2.46,3.74c-2.46,2.55-6.21,3.37-9.75,3.66-2.7.21-5.41.18-8.12.13-4.27-.08-8.82-.3-12.31-2.75-4.26-3-5.74-8.91-10.18-11.57-.49.82.25,2.22.32,3.13.11,1.66.26,3.31.5,5A55.37,55.37,0,0,0,515.06,260.69Z"
        transform="translate(-4.27 -128.48)"
        fill="url(#linear-gradient-22)"
      ></path>
      <path
        d="M538.9,260.84l-5.54-.19a6.82,6.82,0,0,0-2.55.24,2.31,2.31,0,0,0-1.61,1.84,3.14,3.14,0,0,0,.69,1.9,3.71,3.71,0,0,0,.86.95,3.9,3.9,0,0,0,2.32.43l10-.21a1.59,1.59,0,0,0,.78-.16,1.22,1.22,0,0,0,.48-.69,3.85,3.85,0,0,0-1.08-4.07C542.17,260.08,540.21,260.88,538.9,260.84Z"
        transform="translate(-4.27 -128.48)"
        fill="#775339"
      ></path>
    </svg>
  );
};

export default CommuityIcon;

CommuityIcon.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
};
